import { BaseService } from '@services/BaseService'
import axios from 'axios'
const resource = 'hr/choices'

class ChoicesService extends BaseService {
  constructor() {
    super(resource)
  }

  getUnits() {
    return axios.get(`${this.url}/units/`)
  }
}

export const choicesService = new ChoicesService()
